import {
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const ComparisonTable = ({ comparison, colors }) => {
  const { t } = useTranslation("analytics");

  if (!comparison || Object.keys(comparison).length === 0) return null;

  const entries = Object.entries(comparison).map(([assetId, data], i) => ({
    assetId: Number(assetId),
    color: colors[i % colors.length],
    title: data.sales?.[0]?.asset_title || `Asset ${assetId}`,
    revenue: data.total_royalty_revenue || 0,
    impressions: data.total_impressions || 0,
    sales: data.total_sales_count || 0,
    impressionRevenue: data.total_impression_revenue || 0,
  }));

  return (
    <Card variant="outlined" sx={{ mb: 3 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            textTransform: "uppercase",
            fontWeight: 500,
            fontSize: "0.875rem",
            color: "text.secondary",
            mb: 2,
          }}
        >
          {t("comparison.tableTitle")}
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("comparison.columns.title")}</TableCell>
              <TableCell align="right">
                {t("comparison.columns.revenue")}
              </TableCell>
              <TableCell align="right">
                {t("comparison.columns.impressions")}
              </TableCell>
              <TableCell align="right">
                {t("comparison.columns.sales")}
              </TableCell>
              <TableCell align="right">
                {t("comparison.columns.impressionRevenue")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {entries.map((entry) => (
              <TableRow key={entry.assetId}>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        backgroundColor: entry.color,
                        flexShrink: 0,
                      }}
                    />
                    {entry.title}
                  </Box>
                </TableCell>
                <TableCell align="right">
                  ${parseFloat(entry.revenue).toFixed(2)}
                </TableCell>
                <TableCell align="right">
                  {entry.impressions.toLocaleString()}
                </TableCell>
                <TableCell align="right">
                  {entry.sales.toLocaleString()}
                </TableCell>
                <TableCell align="right">
                  ${parseFloat(entry.impressionRevenue).toFixed(2)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default ComparisonTable;
